<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-4">
                <button @click.prevent="activeTab = 1" class="mx-1 btn"
                  :class="{ 'btn-dark': activeTab == 1, 'btn-primary btn-sm': activeTab != 1 }">Expired</button>
                <button @click.prevent="activeTab = 2" class="mx-1 btn"
                  :class="{ 'btn-dark': activeTab == 2, 'btn-primary btn-sm': activeTab != 2 }">14 Days</button>
                <button @click.prevent="activeTab = 3" class="mx-1 btn"
                  :class="{ 'btn-dark': activeTab == 3, 'btn-primary btn-sm': activeTab != 3 }">30 Days</button>
              </div>
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle" type="grow" small></b-spinner>
                    <strong>No Data Found</strong>
                  </div>
                </template>

                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(batch)="data">
                  <span class="fw-medium">{{ data.item.batch }}</span>
                  <small style="cursor: pointer;" @click.prevent="filter = data.item.product"
                    class="d-block fw-medium text-info">{{ data.item.product }}</small>
                </template>

                <template #cell(quantity)="data">
                  {{ data.item.quantity }}
                </template>

                <template #cell(value)="data">
                  {{ commas(data.item.quantity * data.item.buying_price) }}/=
                </template>

                <template #cell(expiry_date)="data">
                  <div v-if="data.item.expiry_date">
                    <div v-if="getDaysDiff(data.item.expiry_date) < 0">
                      <span class="badge bg-danger text-white fw-bold p-1">
                        {{ Math.abs(getDaysDiff(data.item.expiry_date)) }} days ago
                      </span>
                    </div>

                    <div v-else-if="getDaysDiff(data.item.expiry_date) <= 14">
                      <div class="text-warning fw-medium mb-n1">{{ data.item.expiry_date }}</div>
                      <span class="badge bg-warning text-white fw-bold p-1">
                        {{ getDaysDiff(data.item.expiry_date) }} days left
                      </span>
                    </div>

                    <div v-else-if="getDaysDiff(data.item.expiry_date) <= 30">
                      <div class="fw-medium mb-n1">{{ data.item.expiry_date }}</div>
                      <span class="badge bg-dark text-white fw-bold p-1">
                        {{ getDaysDiff(data.item.expiry_date) }} days left
                      </span>
                    </div>

                    <div v-else>
                      <div class="fw-medium">{{ data.item.expiry_date }}</div>
                      <span class="badge bg-success text-white fw-bold p-1">
                        {{ getDaysDiff(data.item.expiry_date) }} days left
                      </span>
                    </div>
                  </div>
                </template>

              </b-table>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { expiredproductComputed, expiredproductMethods } from "@/state/helpers";

export default {
  page: {
    title: "Expired Products",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Expired Products",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Expired Products", active: true },
      ],
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: [],
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "batch", label: "Batch", visible: true, sortable: true },
        { key: "quantity", label: "Quantity", visible: true, sortable: true },
        { key: "value", label: "Value", visible: true, sortable: true },
        { key: "expiry_date", label: "Expiry Date", visible: true, sortable: true },
      ],
      date_today: new Date().toISOString().split('T')[0],
      activeTab: 1
    };
  },
  computed: {
    ...expiredproductComputed,
    List() {
      return this.expiries.length;
    },
    Fields() {
      return this.fields.filter(field => field.visible);
    },
    Items() {
      if (this.filter) {
        return this.expiries.map(d => ({ ...d }));
      }

      return this.expiries
        .filter(d => {
          const daysDiff = this.getDaysDiff(d.expiry_date);
          if (this.activeTab == 1) {
            return daysDiff < 0;
          } else if (this.activeTab == 2) {
            return daysDiff >= 0 && daysDiff <= 14;
          } else if (this.activeTab == 3) {
            return daysDiff > 14 && daysDiff <= 30;
          }
          return true;
        })
        .map(d => ({ ...d }));
    },
    IsBusy() {
      return this.expiries.length == 0;
    },
  },
  mounted() {
    this.fetchExpiredProducts();
    if (this.$route.params.activeTab) {
      this.activeTab = parseInt(this.$route.params.activeTab);
    }
  },
  methods: {
    ...expiredproductMethods,
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getDaysDiff(date) {
      const oneDay = 1000 * 60 * 60 * 24;
      const today = new Date(this.date_today);
      const targetDate = new Date(date);
      return Math.floor((targetDate - today) / oneDay);
    }
  },
};
</script>

<style scoped>
.horizontal-separator {
  margin: 0 15px;
}
</style>
